/**
 * Created by Alex Aguilar on 7/28/2016.
 */
(function(){
    'use strict';

    var autocompleteAirport = {
        templateUrl: 'app/components/autocomplete/airport/autocomplete-airport.html',
        controller: autocompleteAirportController,
        controllerAs: 'vm',
        bindings:{
            ngModel: '=',
            search: '=',
            placeholder: "@",
            target: '@',
            isRequired: '=',
            isDisabled: '=',
            onEventSelect: '&'
        }
    };

    angular
        .module('completeAir')
        .component('autocompleteAirport', autocompleteAirport);

    autocompleteAirportController.$inject = ['$element', '$timeout', '$filter', 'airportService'];

    function autocompleteAirportController($element, $timeout, $filter, airportService){
        var vm = this;

        vm.$postLink = function() {

            var inputComplete = $element.find('.form-control'),
                airports = [],
                resultAirports = [];

            inputComplete.autocomplete({
                minLength: 1,
                delay: 200,
                source: function(request, response){
                    var search = request.term;

                    if(search !== ""){
                        airportService.searchByIataAndName(search).then( function(data){
                            resultAirports = data;
                            airports = dataAutoComplete(data);
                            response(data);
                        });
                    }
                },
                select: function(event, ui){
                    var valueAirport = $filter('capitalize')(ui.item.name) + " " + $filter('capitalize')(ui.item.iata);
                    var posValue = airports.indexOf(valueAirport);

                    vm.ngModel = ui.item.name;
                    vm.airport = resultAirports[posValue];
                    $timeout(function(){
                        vm.onEventSelect({airport: vm.airport});
                    });
                }
            }).on("autocompletechange", function (event, ui) {
                if(ui.item === null) {
                    vm.onEventSelect({airport: null});
                }
            }).autocomplete( "instance" )._renderItem = function( ul, item ) {
                ul.addClass('col-md-5');
                return $( "<li class='ui-item-autocomplete'>" )
                    .append( "<div class='ui-autocomplete-box-content'>"+
                        "<p><span class='bold'>" + item.name + "</span>,&nbsp;" +
                        item._embedded.region.name + ",&nbsp;<span class='text-uppercase'>" + item._embedded.country.name + "</span>" +
                        "&nbsp;<span class='bold pull-right'>(" + item.iata + ")</span></p>"+
                        "</div>" )
                    .appendTo( ul );
            };
        }

        function dataAutoComplete(airports){
            var res = [];
            angular.forEach(airports, function(airport){
                var dataName = $filter('capitalize')(airport.name) + " " + $filter('capitalize')(airport.iata);
                res.push(dataName);
            });
            return res;
        }
    }
})();


